import React from 'react';
import { HorizontalToggleButtons } from '../Components/HorizontalToggleButtons';
import { Gallery } from '../Components/Gallery';
import { ProjectSection } from './ProjectSection';
import { CodeGallery } from '../Components/CodeGallery';

export function WorkSection() {
	const workCategories = [
		{
			id: 'projects',
			label: 'Projects',
			content: <ProjectSection /> 
		},
		{
			id: 'gallery',
			label: 'UI Gallery',
			content: <Gallery />
		},
		{
			id: 'code',
			label: 'Code Snippets',
			content: <CodeGallery />
		}
	];

	return (
		<HorizontalToggleButtons categories={workCategories} />
	);
}